import { useTranslation } from 'react-i18next';
import { CLIENT_ID } from 'src/config';

export const useRedirect = (params: string = '') => {
  const { i18n } = useTranslation();

  return (url?: string) =>
    `${url}?lang=${i18n.language}&clientId=${CLIENT_ID}&${params}`;
};
